import {
	Joyride,
	type EventHandler,
	type Props,
	type Step,
} from 'react-joyride'

const DS = {
	primary: '#55C1E2',
	ink: '#394447',
	onPrimary: '#FFFFFF',
	textBody: '#495456',
	textMuted: '#8A8A8A',
	surfaceCard: '#FFFFFF',
	borderSubtle: '#DBE0E1',
	backdrop: 'rgba(27, 33, 35, 0.55)',
	shadowLg:
		'0 12px 28px rgba(57, 68, 71, 0.12), 0 4px 8px rgba(57, 68, 71, 0.06)',
	fontBody: "'Averta', 'Segoe UI', system-ui, sans-serif",
} as const

const JOYRIDE_Z_INDEX = 1500

interface CustomJoyrideProps {
	run: boolean
	steps: Step[]
	stepIndex: number
	callback: EventHandler
	debug?: boolean
}

function CustomJoyride({
	run,
	steps,
	stepIndex,
	callback,
	debug,
	}: CustomJoyrideProps) {
	const styles: Props['styles'] = {
		overlay: {
			height: document.body.scrollHeight,
		},
		tooltip: {
			backgroundColor: DS.surfaceCard,
			borderRadius: 14,
			border: `1px solid ${DS.borderSubtle}`,
			boxShadow: DS.shadowLg,
			padding: '20px 20px 16px',
			fontFamily: DS.fontBody,
			color: DS.textBody,
		},
		tooltipContainer: {
			textAlign: 'left',
			lineHeight: 1.5,
		},
		tooltipTitle: {
			fontFamily: DS.fontBody,
			fontSize: 18,
			fontWeight: 600,
			letterSpacing: '-0.015em',
			color: DS.ink,
			margin: '0 0 6px',
		},
		tooltipContent: {
			fontFamily: DS.fontBody,
			fontSize: 15,
			color: DS.textBody,
			padding: '4px 0 12px',
		},
		buttonPrimary: {
			backgroundColor: DS.primary,
			color: DS.onPrimary,
			fontFamily: DS.fontBody,
			fontWeight: 600,
			borderRadius: 10,
			padding: '8px 16px',
		},
		buttonBack: {
			color: DS.textMuted,
			fontFamily: DS.fontBody,
			marginRight: 8,
		},
		buttonSkip: {
			color: DS.textMuted,
			fontFamily: DS.fontBody,
			fontSize: 14,
		},
	}

	return (
		<Joyride
			run={run}
			steps={steps}
			stepIndex={stepIndex}
			onEvent={callback}
			loaderComponent={null}
			continuous
			debug={debug}
			floatingOptions={{ autoUpdate: { animationFrame: true } }}
			options={{
				buttons: ['back', 'primary', 'skip'],
				dismissKeyAction: false,
				overlayClickAction: false,
				primaryColor: DS.primary,
				backgroundColor: DS.surfaceCard,
				textColor: DS.ink,
				arrowColor: DS.surfaceCard,
				overlayColor: DS.backdrop,
				scrollOffset: 100,
				showProgress: true,
				skipBeacon: true,
				zIndex: JOYRIDE_Z_INDEX,
				targetWaitTimeout: 1000,
			}}
			styles={styles}
		/>
	)
}

export default CustomJoyride
